// helpers/vectorIdentifier

/*
 This function is no longer used because we
 are taking the DigitizationRequired return from the vector upload now
*/

export default function vectorIdentifier(filename) {

  return filename.match(/\.(ai|eps|epi|eps2|eps3|epsf|epsi|ept|pdf|svg)$/ig) ? true : false

}